// Auto-generated Scipy Components Map

import SciPy_Certificate from "./scipy_components/SciPy_Certificate.jsx";
import SciPy_Constants from "./scipy_components/SciPy_Constants.jsx";
import SciPy_Editor from "./scipy_components/SciPy_Editor.jsx";
import SciPy_Exercises from "./scipy_components/SciPy_Exercises.jsx";
import SciPy_Getting_Started from "./scipy_components/SciPy_Getting_Started.jsx";
import SciPy_Graphs from "./scipy_components/SciPy_Graphs.jsx";
import SciPy_Home from "./scipy_components/SciPy_Home.jsx";
import SciPy_Interpolation from "./scipy_components/SciPy_Interpolation.jsx";
import SciPy_Intro from "./scipy_components/SciPy_Intro.jsx";
import SciPy_Matlab_Arrays from "./scipy_components/SciPy_Matlab_Arrays.jsx";
import SciPy_Optimizers from "./scipy_components/SciPy_Optimizers.jsx";
import SciPy_Quiz from "./scipy_components/SciPy_Quiz.jsx";
import SciPy_Significance_Tests from "./scipy_components/SciPy_Significance_Tests.jsx";
import SciPy_Sparse_Data from "./scipy_components/SciPy_Sparse_Data.jsx";
import SciPy_Spatial_Data from "./scipy_components/SciPy_Spatial_Data.jsx";
import SciPy_Study_Plan from "./scipy_components/SciPy_Study_Plan.jsx";
import SciPy_Syllabus from "./scipy_components/SciPy_Syllabus.jsx";

const scipyComponentsMap = {
  "<SciPy_Certificate />": SciPy_Certificate,
  "<SciPy_Constants />": SciPy_Constants,
  "<SciPy_Editor />": SciPy_Editor,
  "<SciPy_Exercises />": SciPy_Exercises,
  "<SciPy_Getting_Started />": SciPy_Getting_Started,
  "<SciPy_Graphs />": SciPy_Graphs,
  "<SciPy_Home />": SciPy_Home,
  "<SciPy_Interpolation />": SciPy_Interpolation,
  "<SciPy_Intro />": SciPy_Intro,
  "<SciPy_Matlab_Arrays />": SciPy_Matlab_Arrays,
  "<SciPy_Optimizers />": SciPy_Optimizers,
  "<SciPy_Quiz />": SciPy_Quiz,
  "<SciPy_Significance_Tests />": SciPy_Significance_Tests,
  "<SciPy_Sparse_Data />": SciPy_Sparse_Data,
  "<SciPy_Spatial_Data />": SciPy_Spatial_Data,
  "<SciPy_Study_Plan />": SciPy_Study_Plan,
  "<SciPy_Syllabus />": SciPy_Syllabus,
};

export default scipyComponentsMap;
